import { make } from 'vuex-pathify'
import User from '@/api/user'

const state = {
  profile: {},
  //
  users: [],
  user: {},

  loaded_users: false
}

const getters = {
  ...make.getters(state),

  avatarSource: (state) => {
    return state.profile.avatar_source || null
  },
  name: (state) => {
    return state.profile.name
  },
  id: (state) => {
    return state.profile.id || null
  },
  companyId: (state) => {
    return state.profile.company_id || null
  },
  role: (state) => {
    return state.profile.role || null
  },

  profile: (state) => {
    return state.profile || {}
  },

  users: (state) => {
    return state.users
  },

  selectUsers(state) {
    return state.users.map((item) => {
      return {
        value: item.id,
        text: `${item.name} | ${item.job_title}`
      }
    })
  }
}

const mutations = {
  ...make.mutations(state)
}

const actions = {
  async getUserProfile({ commit }) {
    try {
      const response = await User.getUserProfile()
      commit('SET_PROFILE', {
        ...response.data.user
      })
      return response
    } catch (e) {
      return false
    }
  },

  async updateProfile({ commit }, payload) {
    try {
      const response = await User.updateProfile(payload)
      commit('SET_PROFILE', {
        ...response.data.user
      })
      return response
    } catch (e) {
      return false
    }
  },

  async show({ commit }, { id }) {
    try {
      const response = await User.show(id)
      commit('SET_USER', response.data.user)
      return response
    } catch (e) {
      return false
    }
  },

  async store({ commit }, payload) {
    try {
      const response = await User.store(payload)
      return response
    } catch (e) {
      return false
    }
  },

  async update({ commit }, payload) {
    try {
      const response = await User.update(payload.id, payload)
      return response
    } catch (e) {
      return false
    }
  },

  async delete({ commit }, id) {
    try {
      const response = await User.delete(id)
      return response
    } catch (e) {
      return false
    }
  },

  async all({ state, commit }) {
    if (state.loaded_users) {
      return false
    }
    try {
      const response = await User.all()
      commit('SET_USERS', response.data.users)
      commit('SET_LOADED_USERS', true)
    } catch (e) {
      return false
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
